import React from 'react';
export function Problem() {
  return <section className="py-[60px] px-5 bg-brand-dark2" data-id="element-218">
      <div className="max-w-[860px] mx-auto" data-id="element-219">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-220">
          El Problema Real
        </h2>
        <p className="text-base text-brand-gray text-center mb-10 max-w-[600px] mx-auto" data-id="element-221">
          Los libros de finanzas no fueron escritos para ti
        </p>

        <table className="w-full border-collapse mb-9 rounded-xl overflow-hidden" data-id="element-222">
          <thead data-id="element-223">
            <tr data-id="element-224">
              <th className="p-3.5 px-4.5 text-[13px] font-bold uppercase tracking-[1px] bg-brand-red/20 text-brand-red text-left" data-id="element-225">
                ❌ Lo que asumen los libros
              </th>
              <th className="p-3.5 px-4.5 text-[13px] font-bold uppercase tracking-[1px] bg-brand-green/20 text-brand-green text-left" data-id="element-226">
                ✅ Tu realidad
              </th>
            </tr>
          </thead>
          <tbody data-id="element-227">
            <tr data-id="element-228">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-red/5 text-[#cdd9e5]" data-id="element-229">
                Salario fijo cada quincena
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-green/5 text-[#cdd9e5]" data-id="element-230">
                Semanas de $600 y semanas de $1,400
              </td>
            </tr>
            <tr data-id="element-231">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-red/5 text-[#cdd9e5]" data-id="element-232">
                Cuenta de ahorros establecida
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-green/5 text-[#cdd9e5]" data-id="element-233">
                Cada centavo ya tiene destino antes de llegar
              </td>
            </tr>
            <tr data-id="element-234">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-red/5 text-[#cdd9e5]" data-id="element-235">
                Tiempo para hojas de cálculo
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-green/5 text-[#cdd9e5]" data-id="element-236">
                Llegas cansado — necesitas algo simple
              </td>
            </tr>
            <tr data-id="element-237">
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-red/5 text-[#cdd9e5]" data-id="element-238">
                Resultados en 6 meses
              </td>
              <td className="p-3 px-4.5 text-sm border-t border-brand-border bg-brand-green/5 text-[#cdd9e5]" data-id="element-239">
                Necesitas avance esta semana
              </td>
            </tr>
          </tbody>
        </table>

        <div className="flex flex-col gap-3 max-w-[600px] mx-auto" data-id="element-240">
          <div className="flex items-start gap-3 bg-brand-red/10 border border-brand-red/20 rounded-lg p-3.5 px-4.5 text-[15px] text-[#cdd9e5] leading-[1.4]" data-id="element-241">
            <span className="text-lg shrink-0 mt-px" data-id="element-242">🔴</span> Los late fees se
            acumulan solos aunque no hagas nada
          </div>
          <div className="flex items-start gap-3 bg-brand-red/10 border border-brand-red/20 rounded-lg p-3.5 px-4.5 text-[15px] text-[#cdd9e5] leading-[1.4]" data-id="element-243">
            <span className="text-lg shrink-0 mt-px" data-id="element-244">🔴</span> Las suscripciones
            olvidadas siguen cobrando cada mes
          </div>
          <div className="flex items-start gap-3 bg-brand-red/10 border border-brand-red/20 rounded-lg p-3.5 px-4.5 text-[15px] text-[#cdd9e5] leading-[1.4]" data-id="element-245">
            <span className="text-lg shrink-0 mt-px" data-id="element-246">🔴</span> Las fechas de
            vencimiento no tienen lógica con tu día de cobro
          </div>
          <div className="flex items-start gap-3 bg-brand-red/10 border border-brand-red/20 rounded-lg p-3.5 px-4.5 text-[15px] text-[#cdd9e5] leading-[1.4]" data-id="element-247">
            <span className="text-lg shrink-0 mt-px" data-id="element-248">🔴</span> Los acreedores
            llaman. Tú no contestas. La deuda crece.
          </div>
          <div className="flex items-start gap-3 bg-brand-red/10 border border-brand-red/20 rounded-lg p-3.5 px-4.5 text-[15px] text-[#cdd9e5] leading-[1.4]" data-id="element-249">
            <span className="text-lg shrink-0 mt-px" data-id="element-250">🔴</span> Tu pareja
            pregunta. Tú cambias el tema. La tensión aumenta.
          </div>
        </div>

        <div className="text-center text-[clamp(18px,3vw,24px)] font-black text-white bg-brand-dark3 border border-brand-border rounded-xl p-6 mt-8 max-w-[600px] mx-auto" data-id="element-251">
          No es tu culpa.
          <br data-id="element-252" />
          El sistema que te dieron no fue diseñado para ti.
        </div>
      </div>
    </section>;
}